import { gql } from 'graphql-request'

export type ProductQuerySortKey = 'price' | 'orders_count' | undefined
export type ProductQuerySortDirection = 'asc' | 'desc'

function sortBy(options: {
  key: 'price' | 'orders_count' | undefined
  direction: 'asc' | 'desc'
}) {
  if (options.key === 'orders_count') {
    return `order_by: {orders_count: desc}`
  } else if (options.key === 'price') {
    return `order_by: { price: { price_subunit: ${options.direction} } }`
  } else {
    return `order_by: { score: desc, id: desc }`
  }
}

const getProductsQuery = (options: {
  key: 'price' | 'orders_count' | undefined
  direction: 'asc' | 'desc'
}) => gql`
  query getProducts(
    $limit: Int
    $offset: Int
    $search: String
    $status: [String!]
    $type: [String!]
    $topic: [bigint!]
    $product_categories: [bigint!]
    $creator_categories: [bigint!]
    $collections: [bigint!]
    $price_from: Int
    $price_to: Int
    $creator_nickname: String
    $creator_slug: [String!]
    $creator_id: bigint
  ) {
    products(
      limit: $limit
      offset: $offset
      ${sortBy(options)}
      where: {
        _and: [
          { type: { _in: $type } }
          { status: { _eq: "active" } }
          { visible: { _eq: "true" } }
          {
            creator: {
              id: { _eq: $creator_id }
              slug: { _in: $creator_slug }
              nickname: { _eq: $creator_nickname }
              account_status: { _eq: "active" }
              deleted: { _neq: true }
              creator_category_id: { _in: $creator_categories }
            }
          }
          {
            _or: [
              {
                product_contest_entries: {
                  price: {
                    price_subunit: { _gte: $price_from, _lte: $price_to }
                  }
                }
              }
              {
                price: { price_subunit: { _gte: $price_from, _lte: $price_to } }
              }
            ]
          }
          {
            _or: [
              { type: { _eq: "Product::FansiExperience" } }
              {
                product_categories: {
                  product_category_id: { _in: $topic }
                  _or: { product_category_id: { _in: $product_categories } }
                }
              }
            ]
          }
          {
            _or: [
              { name: { _ilike: $search } }
              { creator: { nickname: { _ilike: $search } } }
            ]
          }
          { _not: { type: { _eq: "Product::FansiForBrands" } } }
        ]
      }
    ) {
      id
      slug
      orders_count
      name
      cover: main_photo_url
      created_at
      duration: duration_of_event
      type
      status
      embedded_link
      tags
      bestseller
      newness
      visible
      creator {
        id
        slug
        nickname
        avatar: avatar_link
      }
      categories: product_categories {
        id: product_category_id
        category: product_category {
          id
          name
        }
      }
      entries: product_contest_entries {
        id
        name
        price {
          value: price_subunit
          currency: price_currency
        }
      }
      price {
        currency: price_currency
        value: price_subunit
        price_before_discount: price_before_discount_subunit
      }
      # collection: fansi_collection_group {
      #   id
      #   name
      # }
    }
  }
`

export default getProductsQuery
